import React from "react";

const SkeletonCard = () => (
  <div className="sc-card sc-skeleton-card">
    <div className="sc-card-row">
      <div className="sc-card-left">
        <div className="sc-skeleton-block sc-skeleton-avatar" />
        <div className="sc-info">
          <div className="sc-skeleton-block sc-skeleton-name" />
          <div className="sc-skeleton-block sc-skeleton-ceo" />
          <div className="sc-progress-row">
            <div className="sc-skeleton-block sc-skeleton-progress" />
            <div className="sc-skeleton-block sc-skeleton-status" />
          </div>
        </div>
      </div>
      <div className="sc-card-actions">
        <div className="sc-skeleton-block sc-skeleton-btn" />
      </div>
    </div>
  </div>
);

// Loading placeholder shown while the SME list is being fetched.
const StrategyCanvasSkeleton = ({ count = 5 }) => (
  <div className="sc-list">
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonCard key={index} />
    ))}
  </div>
);

export default StrategyCanvasSkeleton;
